export const USER: 'USER' = 'USER';
const TL: 'TL' = 'TL';
const PM: 'PM' = 'PM';
const ASSOCIATED_TL: 'ASSOCIATED_TL' = 'ASSOCIATED_TL';
const SENIOR_LEAD: 'SENIOR_LEAD' = 'SENIOR_LEAD';
const BOARD: 'BOARD' = 'BOARD';
const MANAGER: 'MANAGER' = 'MANAGER';
const ADMIN: 'ADMIN' = 'ADMIN';

const USER_ROLE = {
    [USER]: `ROLE_${USER}`,
    [TL]: `ROLE_${TL}`,
    [PM]: `ROLE_${PM}`,
    [ASSOCIATED_TL]: `ROLE_${ASSOCIATED_TL}`,
    [SENIOR_LEAD]: `ROLE_${SENIOR_LEAD}`,
    [BOARD]: `ROLE_${BOARD}`,
    [MANAGER]: `ROLE_${MANAGER}`,
    [ADMIN]: `ROLE_${ADMIN}`
};

interface RolesMap {
    [key: string]: {
        name: string;
        color: string;
    };
}

const ROLES_MAP: RolesMap = {
    [USER]: {
        name: 'User',
        color: '#C1C1C1'
    },
    [TL]: {
        name: 'Team Lead',
        color: '#FDFF8C'
    },
    [PM]: {
        name: 'Project Manager',
        color: '#FFAA7D'
    },
    [ASSOCIATED_TL]: {
        name: 'Associated TL',
        color: '#FDFF8C'
    },
    [SENIOR_LEAD]: {
        name: 'Senior Lead',
        color: '#ffc67b'
    },
    [BOARD]: {
        name: 'Board',
        color: '#62a4ff'
    },
    [MANAGER]: {
        name: 'Manager',
        color: '#ff3f38'
    },
    [ADMIN]: {
        name: 'Admin',
        color: '#5AFFBA'
    }
};

const TL_RARING_PERMISSIONS = [USER_ROLE.USER, USER_ROLE.TL, USER_ROLE.ASSOCIATED_TL, USER_ROLE.PM];

const RARING_PERMISSIONS: {[key: string]: string[]} = {
    [USER_ROLE.USER]: [],
    [USER_ROLE.TL]: TL_RARING_PERMISSIONS,
    [USER_ROLE.PM]: TL_RARING_PERMISSIONS,
    [USER_ROLE.ASSOCIATED_TL]: [USER_ROLE.USER],
    [USER_ROLE.SENIOR_LEAD]: TL_RARING_PERMISSIONS,
    [USER_ROLE.BOARD]: [...TL_RARING_PERMISSIONS, USER_ROLE.SENIOR_LEAD],
    [USER_ROLE.MANAGER]: [...TL_RARING_PERMISSIONS, USER_ROLE.SENIOR_LEAD, USER_ROLE.BOARD],
    [USER_ROLE.ADMIN]: []
};

export {USER_ROLE, ROLES_MAP, RARING_PERMISSIONS};
